export const TutorRequestStatuses = {
  InProgress: 'In Progress',
  Approved: 'Approved',
  Rejected: 'Rejected',
};
